"use client";

import { useRef, type FormEvent } from "react";
import Link from "next/link";
import { Alert, Box, Button, Grid, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { SectionCard } from "../ui/SectionCard";

export function StudentForm() {
  const formRef = useRef<HTMLFormElement>(null);
  const preventSubmit = (event: FormEvent<HTMLFormElement>) => event.preventDefault();

  return (
    <SectionCard>
      <Box component="form" ref={formRef} onSubmit={preventSubmit}>
        <Stack spacing={2}>
          <Alert severity="warning" variant="outlined">
            Form ini hanya untuk pratinjau. Tidak ada data yang disimpan atau dikirim.
          </Alert>
          <Typography variant="h2" component="h2">Data murid</Typography>
          <Grid container spacing={1.5}>
            <Grid size={{ xs: 12, sm: 7 }}>
              <TextField fullWidth required size="small" label="Nama murid" name="studentName" autoComplete="off" />
            </Grid>
            <Grid size={{ xs: 12, sm: 5 }}>
              <TextField fullWidth size="small" label="Tanggal lahir" name="birthDate" type="date" slotProps={{ inputLabel: { shrink: true } }} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField fullWidth required size="small" label="Nama keluarga / penanggung jawab" name="familyName" autoComplete="off" />
            </Grid>
          </Grid>
          <Typography variant="h2" component="h2">Enrollment</Typography>
          <Grid container spacing={1.5}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField fullWidth select size="small" label="Outlet" name="outlet" defaultValue="sunter" slotProps={{ inputLabel: { shrink: true } }}>
                <MenuItem value="sunter">Sunter · contoh</MenuItem>
                <MenuItem value="kemang">Kemang · contoh</MenuItem>
                <MenuItem value="cipete">Cipete · contoh</MenuItem>
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField fullWidth select size="small" label="Kelas" name="class" defaultValue="ballet" slotProps={{ inputLabel: { shrink: true } }}>
                <MenuItem value="ballet">Balet Dasar · contoh</MenuItem>
                <MenuItem value="piano">Piano Pemula · contoh</MenuItem>
                <MenuItem value="art">Menggambar · contoh</MenuItem>
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField fullWidth size="small" label="Tanggal mulai" name="startsOn" type="date" slotProps={{ inputLabel: { shrink: true } }} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField fullWidth select size="small" label="Status enrollment" name="status" defaultValue="active" slotProps={{ inputLabel: { shrink: true } }}>
                <MenuItem value="active">Aktif</MenuItem>
                <MenuItem value="cuti">Cuti</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Stack direction={{ xs: "column-reverse", sm: "row" }} spacing={1} justifyContent="flex-end">
            <Button type="reset" variant="outlined" color="inherit">Kosongkan form</Button>
            <Button component={Link} href="/students" variant="text" color="inherit">Batal</Button>
            <Button type="submit" variant="contained" disabled>Simpan belum tersedia</Button>
          </Stack>
        </Stack>
      </Box>
    </SectionCard>
  );
}
